import { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import TallyTape from './tallytape';
import About from './About';

/**
 * The canonical origin. Apex, not www.
 *
 * This is the same host the tape's watermark prints and links to, and the one
 * in the Open Graph tags. Keep all of them in agreement: the footer line on
 * every invoice names this host, and it should be the host that answers.
 *
 * Note that the apex/www redirect itself is configured in the Vercel project's
 * Domains settings, not in vercel.json, so it cannot be verified from the
 * repository. If Vercel is canonicalizing to www, the redirect is running in
 * the wrong direction and should be flipped.
 */
const CANONICAL_ORIGIN = 'https://tallytape.space';

/**
 * Keeps <link rel="canonical"> pointing at the current route.
 *
 * Set per route rather than statically in index.html: a fixed canonical of "/"
 * would tell crawlers that /about is a duplicate of the homepage.
 */
function Canonical() {
  const { pathname } = useLocation();
  useEffect(() => {
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) {
      el = document.createElement('link');
      el.setAttribute('rel', 'canonical');
      document.head.appendChild(el);
    }
    el.setAttribute('href', CANONICAL_ORIGIN + pathname);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <Canonical />
      <Routes>
        <Route path="/" element={<TallyTape />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;
